import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ShareAuthCheckData } from '../../types';
import type { ShareAccessCheckApi } from '../share-access-check-api';

@injectable()
export class ShareAccessCheckApiImpl extends PsHttpService implements ShareAccessCheckApi {
  get options() {
    return {
      baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
      headers: {
        'X-API-Version': '1.0',
      },
    };
  }

  shareAccessCheckForGuest(inputData: ShareAuthCheckData) {
    return this.get<PatSnapCommonResponseData<boolean>>({
      url: '/share/access',
      params: inputData,
    }).then((res) => {
      return res.data as boolean;
    });
  }

  shareAccessCheck(inputData: ShareAuthCheckData) {
    return this.get<PatSnapCommonResponseData<boolean>>({
      url: '/secure-share/access',
      params: inputData,
    }).then((res) => {
      return res.data as boolean;
    });
  }
}
